export default __webpack_public_path__ + "assets/images/3e8f52a332e891fa5ad4acbba0bebece.png";